import React from 'react'
import PropTypes from 'prop-types';
import moment from 'moment';

import { TextInput, LabelGroup, Section, Text, Flex } from '~/views';

import style from './style.css'

export default class CustomNetworkEditor extends React.Component {

  static propTypes = {
    network : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.state = { showDialog : false }
  }

  changePath( path, value, err ) {
    if ( err ) {
      console.log( `error setting ${key} to ${value}` );
      return;
    }
    this.props.onChange( { target : this.props.network, path, value } );
  }

  render() {
    const { network } = this.props
    if ( network == null ) {
      return <div />
    }
    const alias = null
    return (
      <Section title={network.name}>
        <Flex variant="vSpace" direction="column" align="stretch">
          <LabelGroup>
            <label>ID</label>
            <Text type="dim" text={network.id} />
          </LabelGroup>  
          <LabelGroup>
            <label>Name</label>
            <TextInput hint="Name..."
              value={network.name} 
              changeOnReturn 
              onChange={( v, err ) => { this.changePath( 'name', v, err ) }} />
          </LabelGroup>
          <LabelGroup>
            <label>Identifiers</label>
            <TextInput hint="comma separted list"
              value={network.aliasKeys}
              changeOnReturn 
              acceptKey={keyValidator}
              onChange={( v, err ) => { this.changePath( 'aliasKeys', v, err ) }} />
          </LabelGroup>

          <LabelGroup>
            <label />
            <div className={style.identifier}>{`Created ${moment( network.created ).format( 'lll' )}` }</div>
          </LabelGroup>
        </Flex> 
      </Section>
    ) 
  }
}

function keyValidator( evt ) {
  const inp = String.fromCharCode( evt.charCode );
  const c = evt.charCode;
  if ( /[a-zA-Z0-9_\-,]/.test( inp ) ) {
    return true;
  }
  return false;
}
